import { render, staticRenderFns } from "./CollapseLayout.vue?vue&type=template&id=f6cd14fa"
import script from "./CollapseLayout.vue?vue&type=script&lang=js"
export * from "./CollapseLayout.vue?vue&type=script&lang=js"
import style0 from "./CollapseLayout.vue?vue&type=style&index=0&id=f6cd14fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports